import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import TrackingInfoView from './TrackingInfoView';
import DateRangeModel from 'src/model/dateRange.model';
import {
  trackingActions,
  contentSel,
  gettrackingPaginationSel
} from 'src/store/modules/trackingInfo';

interface IDispatchFromProps {
  getTracking(filters: ITrackFilters, pagination: IPagination): void;
}

interface IPagination {
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
}

interface ITrackFilters {
  dates: DateRangeModel | null;
  search: string;
  sortBy: string;
  sortIn: 'ASC' | 'DESC' | 'AUTO';
}

const mapStateToProps = (state: any) => {
  return {
    trackingContent: contentSel(state),
    pagination: gettrackingPaginationSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getTracking: (filters: ITrackFilters, pagination: IPagination) => {
    dispatch(trackingActions.setTrackingPagination(pagination));
    dispatch(trackingActions.getTracking(filters, pagination));
  }
});

export const pureComponent = TrackingInfoView;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(TrackingInfoView));
